/**
 * Helpers de texto para direcciones (sin llamadas de red).
 */

/**
 * @param {string} name
 * @returns {string}
 */
export function normalizeStreetName(name) {
    return String(name || '')
        .trim()
        .replace(/\bAVE?\.?\b/gi, 'Avenida')
        .replace(/\s+/g, ' ')
        .trim();
}
